import { render, staticRenderFns } from "./BundlePaymentDistributions.vue?vue&type=template&id=2a84f794&scoped=true"
import script from "./BundlePaymentDistributions.vue?vue&type=script&lang=js"
export * from "./BundlePaymentDistributions.vue?vue&type=script&lang=js"
import style0 from "./BundlePaymentDistributions.vue?vue&type=style&index=0&id=2a84f794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a84f794",
  null
  
)

export default component.exports